import type { MarketplacePaginatedRes as PaginatedRes } from '@dvb/common';

import { authAxios } from '@school-manage/api/client';

import type {
  CourseTask,
  CourseTaskSubmitRecord,
  GetTasksArgs,
  GetTaskSubmitRecordsArgs,
  SubmitTaskArgs,
  UploadTempFileRes,
} from './tasks.types';

export const getTasksRequest = async ({
  courseUuid,
  cursor,
  search,
  status,
}: GetTasksArgs) => {
  const { data } = await authAxios.post<PaginatedRes<CourseTask[]>>(
    '/api/v1/course/task-list',
    {
      course_uuid: courseUuid,
      cursor,
      search,
      status,
    }
  );
  return data;
};

export const getTaskDetailRequest = async (taskId: string) => {
  const { data } = await authAxios.post<CourseTask>(
    '/api/v1/course/task-details',
    {
      task_uuid: taskId,
    }
  );
  return data;
};

export const getTaskSubmitRecordsRequest = async ({
  courseTaskUuid,
  courseUuid,
  cursor,
}: GetTaskSubmitRecordsArgs) => {
  const { data } = await authAxios.post<PaginatedRes<CourseTaskSubmitRecord[]>>(
    '/api/v1/course/task-result-list',
    {
      course_task_uuid: courseTaskUuid,
      course_uuid: courseUuid,
      cursor,
    }
  );
  return data;
};

export const getTaskSubmitRecordDetailRequest = async (
  taskResultUuid: string
) => {
  const { data } = await authAxios.post<CourseTaskSubmitRecord>(
    '/api/v1/course/task-result-details',
    {
      task_result_uuid: taskResultUuid,
    }
  );
  return data;
};

export const submitTaskRequest = async ({
  aiRecord,
  formData,
  taskUuid,
}: SubmitTaskArgs) => {
  const { data } = await authAxios.post<{ record_id: string }>(
    '/api/v1/course/task-submit',
    {
      ai_motion: aiRecord,
      manual_submit: formData,
      task_uuid: taskUuid,
    }
  );
  return data;
};

export const uploadTempFileRequest = async (file: Blob | File) => {
  const formData = new FormData();
  formData.append('file', file);

  const { data } = await authAxios.post<UploadTempFileRes>(
    '/api/v1/file/upload-temp-file',
    formData,
    {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    }
  );
  return data;
};
